/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Country, Merchant, States } from "../../../../models";
import { MerchantService } from "../../../../services";

@Component({
  selector: "app-legal-entity-edit",
  templateUrl: "./legal-entity-edit.component.html"
})
export class LegalEntityEditComponent {
  @Input() parentGroup!: FormGroup;
  @Input() legalEntity!: FormGroup;
  @Input("merchant") merchant!: Merchant;
  states = States;
  countries = Country;

  constructor(private merchantService: MerchantService) {}

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  isInstaMed(): boolean {
    return this.merchantService.isInstaMed(this.merchant);
  }

  get legalEntityFormControls() {
    return this.legalEntity.controls;
  }
}
